import { ArrowDirection, AttachedFile, IGalleryItemDetails } from "modules/gallery";

type UseImageArrowProps = {
    selectedImageDetails: IGalleryItemDetails[] | AttachedFile[];
    focusedImage: IGalleryItemDetails | AttachedFile;
    selectAndScrollToImage: (newImage: IGalleryItemDetails | AttachedFile, index?: number) => void;
}

/**
 * Contains logic for the arrows on the sides of the main preview image for inline galleries.
 */
const useImageArrow = (props: UseImageArrowProps): ((directionToMove: ArrowDirection) => void) => {
    const onImageArrowClicked = (directionToMove: ArrowDirection) => {
        var { newSelectedImage, imageIndex } = selectAdjacentImage(directionToMove);
        props.selectAndScrollToImage(newSelectedImage, imageIndex);
    };
    
    const selectAdjacentImage = (directionToMove: ArrowDirection) => {
        const currentImageIndex = props.selectedImageDetails.indexOf(props.focusedImage as any);
        let newSelectedImage = props.selectedImageDetails[currentImageIndex];
        let imageIndex = 0;

        if (directionToMove === ArrowDirection.Left) {
            imageIndex = currentImageIndex - 1;
            if(currentImageIndex === 0) {
                imageIndex = props.selectedImageDetails.length - 1;
            }

            newSelectedImage = props.selectedImageDetails[imageIndex];
        }
        else {
            imageIndex = currentImageIndex + 1;
            if(currentImageIndex === props.selectedImageDetails.length - 1) {
                imageIndex = 0;
            }

            newSelectedImage = props.selectedImageDetails[imageIndex];
        }

        return { newSelectedImage, imageIndex };
    }

    return onImageArrowClicked
}

export { useImageArrow };
